import { render, staticRenderFns } from "./BankAndPensionsTab.vue?vue&type=template&id=54326e2e&scoped=true"
import script from "./BankAndPensionsTab.vue?vue&type=script&lang=js"
export * from "./BankAndPensionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54326e2e",
  null
  
)

export default component.exports